import React from 'react';
import { useLocation } from 'react-router-dom';
import WhatsNewStrip from './WhatsNewStrip';
import Navbar from './Navbar';
import Footer from './Footer';
import FloatingStack from './FloatingStack';
import ScrollProgress from './ScrollProgress';
import CookieBanner from './CookieBanner';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isFeed = pathname.startsWith('/feed');
  return (
    <div className="App eh-scanlines">
      <ScrollProgress />
      {/* Site-wide "What's New" strip replaces the old scrolling MARQUEE text. */}
      {!isFeed && <WhatsNewStrip />}
      <Navbar />
      <main>{children}</main>
      {!isFeed && <Footer />}
      <FloatingStack />
      <CookieBanner />
    </div>
  );
};
export default Layout;
